module.exports = __webpack_public_path__ + "static/media/logo.254a17a3.svg";